<template>
  <v-dialog max-width="540" :value="visible" content-class="rounded-10" style="z-index: 15" @input="$emit('input', $event)">
    <v-card class="staff-dialog-card">
      <!-- 상단 왕관 장식 -->
      <div class="dialog-header-deco">
        <v-img width="180" height="32" contain class="mx-auto mt-2" src="@/assets/deco/line_0.png"></v-img>
      </div>

      <!-- 타이틀 -->
      <div class="dialog-title-section">
        <p v-if="staff" class="text-center font-danjunghae mb-0" style="color: #ab8181; font-size: 30px" :lang="$domLang">{{ getMultiLangValue(staff.name, lang) }}</p>
      </div>

      <v-card-text class="staff-card-content">
        <div v-if="staff" class="staff-detail-content">
          <!-- 작가 소개 이미지 (1500x600 비율) -->
          <div v-if="getProfileImageUrl(staff)" class="staff-intro-image">
            <v-img :src="getProfileImageUrl(staff)" :lazy-src="require('@/assets/placeholder.jpg')" aspect-ratio="2.5" class="rounded-none">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </div>
          <div v-else class="no-image-placeholder rounded-none">
            <v-icon size="80" color="grey lighten-2">mdi-account-circle</v-icon>
          </div>

          <!-- 작가 정보 -->
          <div class="staff-info mt-4">
            <div v-if="staff.title" class="staff-title text-body-1 mb-2" style="color: #666">
              {{ staff.title }}
            </div>
            <div v-if="getStaffDisplayIntroduction(staff)" class="staff-introduction">
              {{ getStaffDisplayIntroduction(staff) }}
            </div>
          </div>
        </div>
        <div v-else class="text-center py-8">
          <span class="grey--text text-body-1">작가 정보를 불러올 수 없습니다.</span>
        </div>
      </v-card-text>
      <v-card-actions class="d-flex justify-center pb-4 px-6" style="gap: 12px">
        <v-btn color="white" class="dialog_btn rounded-2" style="font-size: 18px; color: #666" width="45%" depressed @click="$emit('cancel')" large> 취소 </v-btn>
        <v-btn color="#EF7FAB" dark class="dialog_btn rounded-2" style="font-size: 18px" width="45%" depressed @click="$emit('select')" large> 선택 </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex"
import { getMultiLangValue } from "@/util/utils"

export default {
  name: "StaffDetailDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    staff: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapState(["lang"]),

    portfolioImages() {
      if (!this.staff || !this.staff.portfolioImages) {
        return []
      }

      try {
        const parsed = typeof this.staff.portfolioImages === "string" ? JSON.parse(this.staff.portfolioImages) : this.staff.portfolioImages

        return Array.isArray(parsed) ? parsed : []
      } catch (e) {
        console.error("Failed to parse portfolioImages:", e)
        return []
      }
    },

    hasPortfolioImages() {
      return this.portfolioImages.length > 0
    },
  },
  methods: {
    getMultiLangValue,

    getStaffDisplayIntroduction(staff) {
      if (!staff) return ""
      return getMultiLangValue(staff.introduction, this.lang)
    },

    getProfileImageUrl(staff) {
      console.log("staff", staff)
      if (!staff || !staff.profile_staff_image || staff.profile_staff_image.includes("user/profile_image/default.png")) {
        return null
      }
      return `/upload/user/profile_image/${staff.profile_staff_image}`
    },

    getPortfolioImageUrl(imagePath) {
      if (!imagePath) return ""
      // 이미지 경로가 절대 경로인 경우 그대로 반환
      if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
        return imagePath
      }
      // 상대 경로인 경우 /upload 경로 추가
      return `/upload/staff/portfolio/${imagePath}`
    },
  },
}
</script>

<style scoped>
.staff-dialog-card {
  background-color: #fffbf2 !important;
  border: 3px solid #dadada !important;
  border-radius: 8px;
  position: relative;
}

.dialog-header-deco {
  padding-top: 16px;
}

.dialog-title-section {
  padding: 0px 16px 8px;
}

.staff-card-content {
  padding: 16px 0px 24px !important;
}

.dialog_btn {
  border: 2px solid #dadada !important;
  font-size: 16px;
}

.staff-detail-content {
  padding: 8px 0;
}

.staff-intro-image {
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
}

.no-image-placeholder {
  width: 100%;
  aspect-ratio: 2.5;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
}

.staff-info {
  text-align: center;
}

.staff-title {
  font-weight: 500;
}

.staff-introduction {
  color: #737373;
  font-size: 16px;
  line-height: 1.6;
  white-space: pre-wrap;
  text-align: center;
}

.portfolio-images-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  padding: 8px 0;
}

.portfolio-image-item {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.rounded-lg {
  border-radius: 8px;
  border: 2px solid #f5e4e4;
}
</style>
